import { Injectable } from '@angular/core';
import { VideoSearchResult } from '../model/video-search-result.model';
import { Scene } from '../model/scene';
import { VideoScenesService, VideoSceneDTO } from '@solverml/api';
import { VideoStreamingService } from './video-streaming.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VideoSceneService {

  constructor(
    private videoScenesService: VideoScenesService,
    private videoStreamingService: VideoStreamingService
  ) { }

  async getScenes(videoInfo: VideoSearchResult): Promise<Scene[]> {
    let scenes: Scene[] = [];

    if (!videoInfo || !videoInfo.id) {
      return scenes;
    }

    const endpointResults: VideoSceneDTO[] = await lastValueFrom(this.videoScenesService.getAllScenes(videoInfo.id));

    for (const scene of endpointResults) {


      scenes.push({
        id: scene.id,
        title: scene.label,
        start_time_in_seconds: scene.start_time_in_seconds,
        end_time_in_seconds: scene.end_time_in_seconds,
        analyzable: scene.analyzable,
        thumbnail_url: scene.thumbnail_url,
        data: scene.data || [] // Optional data field for additional information
      });
    }

    return scenes.sort((a, b) => a.start_time_in_seconds - b.start_time_in_seconds);
  }

  async getSceneCountForVideo(videoId: string): Promise<number> {
    if (!videoId) {
      return 0;
    }

    const scenes = await lastValueFrom(this.videoScenesService.getAllScenes(videoId));
    return scenes.length;
  }
}
